export const CLOSE_WELCOME_MESSAGE = 'CLOSE_WELCOME_MESSAGE';

export const closeWelcomeMessage = () => ({ type: CLOSE_WELCOME_MESSAGE });



// WEBPACK FOOTER //
// ./src/containers/WelcomeMessage/actions.js